const initialState = {
  editMode: {
    bookInfo: {},
    status: false,
  },
  books: [
    {
      id: 1,
      name: "Slow Horses (Deluxe Edition)",
      author: "Mick Herron",
      thumbnail:
        "https://m.media-amazon.com/images/I/51Ga5GuElyL._SX331_BO1,204,203,200_.jpg",
      price: 14,
      rating: 3,
      featured: false,
    },
  ],
};

export default initialState;
